import { Box, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

interface Props {
  size?: number;
  withText?: boolean;
  to?: string;
  textColor?: string;
}

export default function BrandMark({ size = 36, withText = true, to = '/', textColor }: Props) {
  const dot = Math.round(size * 0.22);
  return (
    <Box
      component={RouterLink}
      to={to}
      sx={{ display: 'inline-flex', alignItems: 'center', gap: 1.25, textDecoration: 'none' }}
      aria-label="Baton home"
    >
      <Box
        sx={{
          position: 'relative',
          width: size,
          height: size,
          borderRadius: 1.5,
          background: 'linear-gradient(135deg, #0b5394 0%, #1e88e5 100%)',
          color: '#fff',
          display: 'grid',
          placeItems: 'center',
          fontWeight: 800,
          fontSize: Math.round(size * 0.55),
          letterSpacing: '-1px',
        }}
        aria-hidden
      >
        B
        <Box
          sx={{
            position: 'absolute',
            bottom: Math.round(size * 0.11),
            right: Math.round(size * 0.09),
            width: dot,
            height: dot,
            borderRadius: '50%',
            bgcolor: 'secondary.main',
          }}
        />
      </Box>
      {withText && (
        <Typography
          variant="h6"
          sx={{ fontWeight: 700, color: textColor || 'text.primary', lineHeight: 1 }}
        >
          Baton
        </Typography>
      )}
    </Box>
  );
}
